export enum PublicRequestStatusEnum {
    PENDING = 'PENDING',
    COMPELETED = 'COMPELETED',
}
